import { render, staticRenderFns } from "./longtext.vue?vue&type=template&id=606df50c"
import script from "./longtext.vue?vue&type=script&lang=js"
export * from "./longtext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports